document.addEventListener("DOMContentLoaded", () => {
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
          slide.setAttribute("aria-selected", "false");
          slide.removeAttribute("aria-current");
        });
      }

      function addActive(idx) {
        const slide = slider.slides[idx];
        if (!slide) return;
        slide.classList.add("active");
        slide.setAttribute("aria-selected", "true");
        slide.setAttribute("aria-current", "true");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
          if (slide.tagName !== "BUTTON") {
            slide.setAttribute("tabindex", "0");
            slide.setAttribute("role", "tab");
            slide.addEventListener("keydown", (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                main.moveToIdx(idx);
              }
            });
          }
        });
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }

  function navigation(slider) {
    let wrapper, dots, arrowLeft, arrowRight;

    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }
    function createButton(className, ariaLabel) {
      var btn = document.createElement("button");
      btn.setAttribute("type", "button");
      var classNames = className.split(" ");
      classNames.forEach((name) => btn.classList.add(name));
      if (ariaLabel) btn.setAttribute("aria-label", ariaLabel);
      return btn;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createButton("arrow arrow--left", "Previous image");
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowRight = createButton("arrow arrow--right", "Next image");
      arrowRight.addEventListener("click", () => slider.next());

      arrowRight.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-6 h-6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" /></svg>`;
      arrowLeft.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-6 h-6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" /></svg>`;

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv("navigation-wrapper");
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv("dots");
      dots.setAttribute("role", "tablist");
      dots.setAttribute("aria-label", "Slide navigation");
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createButton(
          "dot",
          "Go to slide " + (idx + 1) + " of " + slider.track.details.slides.length
        );
        dot.setAttribute("role", "tab");
        dot.addEventListener("click", () => slider.moveToIdx(idx));
        dots.appendChild(dot);
      });
      wrapper.appendChild(dots);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled");
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled");
      Array.from(dots.children).forEach(function (dot, idx) {
        if (idx === slide) {
          dot.classList.add("dot--active");
          dot.setAttribute("aria-current", "true");
          dot.setAttribute("aria-selected", "true");
        } else {
          dot.classList.remove("dot--active");
          dot.removeAttribute("aria-current");
          dot.setAttribute("aria-selected", "false");
        }
      });
    }

    slider.on("created", () => {
      markup();
      updateClasses();
    });
    slider.on("optionsChanged", () => {
      console.log(2);
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  }

  var mainSlider = new KeenSlider(".layout--thumbnails .gallery__main-images", {
    slides: {
      perView: 1,
      spacing: 16,
    },
  });
  var thumbnails = new KeenSlider(
    ".layout--thumbnails .gallery__thumbnails",
    {
      initial: 0,
      slides: {
        perView: 4,
        spacing: 10,
      },
    },
    [ThumbnailPlugin(mainSlider), navigation] // Pass mainSlider directly
  );
});
